var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "line-icon_svg__Layer_2",
  "data-name": "Layer 2",
  viewBox: "0 0 50 50"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".line-icon_svg__cls-1{fill:#102a56}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "line-icon_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "line-icon_svg__LINE_LOGO",
  "data-name": "LINE LOGO"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.73 0H11.27C5.05 0 0 5.05 0 11.27v27.46C0 44.95 5.05 50 11.27 50h27.46C44.95 50 50 44.95 50 38.73V11.27C50 5.05 44.95 0 38.73 0m8.43 38.73c0 4.65-3.78 8.43-8.43 8.43H11.27c-4.65 0-8.43-3.78-8.43-8.43V11.27c0-4.65 3.78-8.43 8.43-8.43h27.46c4.65 0 8.43 3.78 8.43 8.43z",
  className: "line-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.12 26.95h-4.68c-.18 0-.32-.14-.32-.32v-7.27c0-.18.14-.33.32-.33h4.68c.18 0 .32.14.32.32v1.18c0 .18-.14.32-.32.32h-3.18v1.23h3.18c.18 0 .32.14.32.32v1.18c0 .18-.14.32-.32.32h-3.18v1.23h3.18c.18 0 .32.14.32.32v1.18c0 .18-.14.32-.32.32M18.79 26.95c.18 0 .32-.14.32-.32v-1.18c0-.18-.14-.32-.32-.32h-3.18v-5.78c0-.18-.14-.32-.32-.32h-1.18c-.18 0-.32.14-.32.32v7.27c0 .18.14.32.32.32h4.68Z",
  className: "line-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.82,
  height: 7.91,
  x: 20.11,
  y: 19.04,
  className: "line-icon_svg__cls-1",
  rx: 0.91,
  ry: 0.91
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.66 19.04h-1.18c-.18 0-.32.14-.32.32v4.32l-3.33-4.49-.03-.03-.02-.02-.02-.02s-.01 0-.02-.01h-1.35c-.18 0-.32.14-.32.32v7.28c0 .18.14.32.32.32h1.18c.18 0 .32-.14.32-.32v-4.32l3.33 4.5s.05.06.08.08.01 0 .02.01h.05s.05.01.08.01h1.18c.18 0 .32-.14.32-.32v-7.28c0-.18-.14-.32-.32-.32Z",
  className: "line-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.99 6.28c-10.76 0-19.51 7.34-19.51 16.37 0 7.81 6.4 14.4 15.37 16l-.11.65c-.09.49-.35 1.99.71 3.24.64.77 1.57 1.19 2.62 1.19.62 0 1.28-.15 2.02-.46 1.93-.81 10.24-5.95 14.14-10.43 2.87-3.17 4.27-6.5 4.27-10.19 0-9.03-8.75-16.37-19.51-16.37m13.1 24.69c-3.5 4.03-11.32 8.93-13.1 9.68s-1.52-.48-1.44-.9c.04-.25.24-1.43.24-1.43.06-.43.11-1.09-.05-1.51-.19-.46-.93-.7-1.47-.82-8.01-1.06-13.94-6.66-13.94-13.35 0-7.46 7.48-13.53 16.67-13.53s16.67 6.07 16.67 13.53c0 2.99-1.16 5.67-3.57 8.32Z",
  className: "line-icon_svg__cls-1"
})))));
export default SvgLineIcon;